import fetchWithAuth from './base';
import { ListResponse } from '@/types/common';
import type {
  ApiCreditConfig,
  ApiCreditUsage,
  ApiCreditUsageBreakdownItem,
  ApiCreditUsageGraph,
  UpdateCreditConfigRequest,
  ApiCreditUsageSummary,
  ApiCycle,
  ApiPlan,
  ApiSubscription,
} from '@/types/usage';
import type { ApiCreditPackage } from '@/types/stripe';

export async function getPlans(clientId: string): Promise<ApiPlan[]> {
  const response = await fetchWithAuth(`/api/client/${clientId}/plan`, { method: 'GET' });
  const result: ListResponse<ApiPlan> = await response.json();
  return result.data;
}

// ── New raw API types ────────────────────────────────────────────────────────

// ── New API functions ────────────────────────────────────────────────────────

export async function getCycles(clientId: string): Promise<ListResponse<ApiCycle>> {
  const response = await fetchWithAuth(`/api/client/${clientId}/cycle`, {
    method: 'GET',
  });
  return response.json();
}

export async function getCreditUsage(clientId: string, cycleId: string): Promise<ApiCreditUsage> {
  const response = await fetchWithAuth(`/api/client/${clientId}/cycle/${cycleId}/credit_usage`, {
    method: 'GET',
  });
  return response.json();
}

export async function getSubscription(clientId: string): Promise<ApiSubscription> {
  const response = await fetchWithAuth(`/api/client/${clientId}/subscription`, {
    method: 'GET',
  });
  return response.json();
}

export async function getCreditUsageBreakdown(
  clientId: string,
  cycleId: string
): Promise<ListResponse<ApiCreditUsageBreakdownItem>> {
  const response = await fetchWithAuth(
    `/api/client/${clientId}/cycle/${cycleId}/credit_usage_breakdown`,
    { method: 'GET' }
  );
  return response.json();
}

export async function getCreditUsageSummary(
  clientId: string,
  startDate: string,
  endDate: string
): Promise<ApiCreditUsageSummary> {
  const response = await fetchWithAuth(
    `/api/client/${clientId}/credit_usage/summary?start_date=${startDate}&end_date=${endDate}`,
    { method: 'GET' }
  );
  return response.json();
}

export async function getCreditUsageGraph(
  clientId: string,
  month: string,
  year: string
): Promise<ApiCreditUsageGraph> {
  const response = await fetchWithAuth(
    `/api/client/${clientId}/credit_usage/graph?month=${month}&year=${year}`,
    { method: 'GET' }
  );
  return response.json();
}

export async function getCreditConfig(clientId: string): Promise<ApiCreditConfig> {
  const response = await fetchWithAuth(`/api/client/${clientId}/credit_config`, {
    method: 'GET',
  });
  return response.json();
}

export async function updateCreditConfig(
  clientId: string,
  updates: UpdateCreditConfigRequest
): Promise<ApiCreditConfig> {
  const response = await fetchWithAuth(`/api/client/${clientId}/credit_config`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
  return response.json();
}

export async function getCreditPackages(clientId: string): Promise<ListResponse<ApiCreditPackage>> {
  const response = await fetchWithAuth(`/api/client/${clientId}/credit_package`, {
    method: 'GET',
  });
  return response.json();
}
